import {SET_SQUARE_STATUS, SET_MESSAGE, SET_STRIPE_STATUS} from './mutationTypes'

const SQUARE_URL = process.env.SQUARE_URL;

export default {
  loadSquareLib ({commit, getters}) {
    if (getters.squareStatus == 'none') {
      commit(SET_SQUARE_STATUS, 'loading')
      let script = document.createElement('script')
      script.onload = () => {
        commit(SET_SQUARE_STATUS, 'loaded')
      }

      script.async = true
      script.src = SQUARE_URL
      document.head.appendChild(script)
    }
  },

  loadStripeLib ({commit, getters}) {
    if (getters.stripeStatus == 'none') {
      commit(SET_STRIPE_STATUS, 'loading')
      let script = document.createElement('script')
      script.onload = () => {
        commit(SET_STRIPE_STATUS, 'loaded')
      }

      script.async = true
      script.src = "https://js.stripe.com/v3"
      document.head.appendChild(script)
    }
  },

  success ({dispatch}, message) {
    dispatch('message', {type: 'success', text: message})
  },
  error ({dispatch}, message) {
    dispatch('message', { type: 'error', text: message})
  },
  message ({commit}, message) {
    commit(SET_MESSAGE, message)
  }
}
